<template>
  <div class="container searchbar">

      <div class="input-group">
        <input
          v-model="what"
          @keydown.13.prevent="parseSearchString"
          type="text"
          class="form-control"
          placeholder="Search ..."
        />

        <div class="input-group-append">
          <button
            @click="parseSearchString"
            class="btn btn-outline-secondary"
            type="button"
          >
            <i class="fas fa-search"></i>
          </button>
        </div>
        <div class="input-group-append">
          <button
            @click="openSearchModal"
            class="btn btn-outline-secondary"
            type="button"
          >
            <i class="fas fa-search-plus"></i>
          </button>
        </div>
        <div class="input-group-append">
                <v-checkbox
                    v-model="chk_active"
                    label="Actif"
                    @click="updateActive"
                    >
                </v-checkbox>
          </div>

      </div>

  </div>

</template>

<script>
export default {
  name: "SearchForm",
  components: {
  },
  props: {
    inSearch : Boolean
  },
   data() {
    return {
      what : "",
      chk_active : true,
    }
  },
  beforeMount() {
    // récupération des parametres de la route
    if (this.inSearch) {
        this.what = this.$route.params.search
        this.chk_active = (this.$route.params.active === "true")
    }
  },
  methods: {
    parseSearchString() {
      // Trim search string
      const trimmedSearchString = this.what.trim();
      if (trimmedSearchString !== "") {
        // Split search string
        const searchParams = trimmedSearchString.split(/\s+/);
        // Emit event
          var newPath = "/search/"+searchParams+"/active/"+this.chk_active
          var oldPath = this.$router.currentRoute.fullPath
          if (newPath !== oldPath) {
            this.$router.push("/search/"+searchParams+"/active/"+this.chk_active);
          }
         this.$emit("search", searchParams, this.chk_active);
        // Reset input field
        // this.searchString = '';
      }
    },
    openSearchModal () {
        this.$emit("openSearchModal")
        this.what = ""
    },
    updateActive () {
        if (this.inSearch)
            this.parseSearchString()
    }
  },
};
</script>

<style scoped>
input,
button {
  box-shadow: none !important;
}

.form-control {
  border-color: #6c757d;
}



.v-input--selection-controls.v-input
{
align-items:center;
}


.v-input__control {
margin-left : 10px;
}

.v-input--selection-controls .v-input__slot  {
margin : 0px;
}


.searchbar .v-label {
margin : 0px;
}

.searchbar .v-messages {
  display : none
}

    .check-button:hover {
        color: #ddd;
    }

</style>
